import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Icon from "../elements/icon";
import Button from "../elements/button";
import Popover2 from "../overlays/popover-2";
import KeyPressManager from "../../utils/keypress-manager";
import { prevFocusWithWrap, nextFocusWithWrap } from "../../utils/accessibility-utils";

var Listbox = function Listbox(_ref) {
  var className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      value = _ref.value,
      _ref$emptyValue = _ref.emptyValue,
      emptyValue = _ref$emptyValue === void 0 ? "Select..." : _ref$emptyValue,
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onClose = _ref.onClose,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "dynamic" : _ref$size,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? "chevron-down" : _ref$icon,
      _ref$buttonClassName = _ref.buttonClassName,
      buttonClassName = _ref$buttonClassName === void 0 ? "" : _ref$buttonClassName,
      _ref$hideSelectedValu = _ref.hideSelectedValue,
      hideSelectedValue = _ref$hideSelectedValu === void 0 ? false : _ref$hideSelectedValu,
      _ref$onOpen = _ref.onOpen,
      onOpen = _ref$onOpen === void 0 ? function () {} : _ref$onOpen;
  var width = size === "small" ? "100" : size === "large" ? "300" : "200";
  var widthClass = size !== "dynamic" && size !== "compact" && "et-listbox--width-".concat(width);
  return /*#__PURE__*/React.createElement(Popover2, {
    className: className,
    placement: "bottom-start",
    onClose: onClose,
    trigger: function trigger(_ref2) {
      var togglePopover = _ref2.togglePopover;
      return /*#__PURE__*/React.createElement(Button, {
        className: classNames("et-listbox--trigger", buttonClassName, widthClass, {
          "has-value": value !== "" && value !== emptyValue
        }),
        type: size === "compact" ? "simple" : "secondary",
        onClick: function onClick() {
          togglePopover();
          onOpen();
        },
        accessibilityAttributes: {
          "aria-haspopup": "listbox"
        },
        label: ariaLabel,
        disabled: disabled
      }, !hideSelectedValue && /*#__PURE__*/React.createElement("div", {
        className: "et-listbox--label"
      }, value || emptyValue), /*#__PURE__*/React.createElement(Icon, {
        size: 1,
        icon: icon
      }));
    }
  }, function (_ref3) {
    var closePopover = _ref3.closePopover;
    return /*#__PURE__*/React.createElement(KeyPressManager, {
      component: "div",
      onArrowDown: function onArrowDown(node) {
        return nextFocusWithWrap(node);
      },
      onArrowUp: function onArrowUp(node) {
        return prevFocusWithWrap(node);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "et-listbox--content",
      role: "listbox"
    }, children({
      closePopover: closePopover
    })));
  });
};

Listbox.propTypes = {
  className: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
  value: PropTypes.string,
  emptyValue: PropTypes.string,
  children: PropTypes.any,
  disabled: PropTypes.bool,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium", "large", "dynamic", "compact"]),
  icon: PropTypes.string,
  buttonClassName: PropTypes.string,
  hideSelectedValue: PropTypes.bool,
  onOpen: PropTypes.func
};
export default Listbox;